import { ChevronDownIcon } from '@chakra-ui/icons';
import { Button, useDisclosure, Grid, Text } from '@chakra-ui/react';
import React, { FC } from 'react';

import { useRouterIntentState } from '@app/state/routerIntentStore';
import { TokenIcon } from '@app/components/TokenIcon';
import { SelectTokenModal } from '@app/screens/router-intent/components/SelectToken/SelectTokenModal';

export const SelectToken: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { sourceToken, sourceNetwork } = useRouterIntentState();

  return (
    <>
      <Button
        isDisabled={!sourceNetwork}
        onClick={onOpen}
        minWidth={['110px', '160px']}
        width="fit-content"
        h="100%"
        bg="transparent"
        _hover={{
          background: 'transparent'
        }}
        px={0}
        py="4px"
        borderRadius={4}
        sx={{ cursor: 'pointer' }}
      >
        <Grid
          gridTemplateColumns="24px 1fr 24px"
          gridColumnGap="6px"
          gridRowGap={0}
          w="100%"
          alignItems="center"
        >
          <TokenIcon
            symbol={sourceToken?.symbol}
            iconUrl={sourceToken?.logoUri}
          />
          <Text
            fontSize="16px"
            fontWeight="500"
            lineHeight="20px"
            color="neutral.100"
            textAlign="left"
            overflow="hidden"
            textOverflow="ellipsis"
          >
            {sourceToken ? sourceToken.symbol : 'Select token'}
          </Text>
          <ChevronDownIcon />
        </Grid>
      </Button>
      <SelectTokenModal onClose={onClose} isOpen={isOpen} />
    </>
  );
};
